module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/ponderosa_bw-e7c2e569f9fef1ee9129d2cb43153056.jpg";